import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { EmailService } from '@services/email/email.service';
import { SendEmailRequest } from '@models/email/sendEmailRequest.model';
import { ReceiverDto } from '@models/email/receiverDto.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';

@Component({
  selector: 'app-test-email-modal',
  templateUrl: './test-email-modal.component.html',
  styleUrls: ['./test-email-modal.component.css']
})
export class TestEmailModalComponent {

  form: FormGroup;
  enviando = false;

  private readonly emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  constructor(
    private fb: FormBuilder,
    private emailService: EmailService,
    private dialogRef: MatDialogRef<TestEmailModalComponent>,
    private spinner: NgxSpinnerService,
    private snackBar: SnackBarService
  ) {
    this.form = this.fb.group({
      destinatarios: ['', Validators.required],
      asunto: ['', Validators.required],
      body: ['', Validators.required]
    });
  }

  get destinatariosCtrl() { return this.form.get('destinatarios')!; }
  get asunto() { return this.form.get('asunto')!; }
  get body() { return this.form.get('body')!; }

  private parsearDestinatarios(): string[] | null {
    this.spinner.show('spinerEmail')
    const valores = (this.destinatariosCtrl.value || '')
      .split(',')
      .map((e: string) => e.trim())
      .filter((e: string) => e.length > 0);

    const invalidos = valores.filter((e: string) => !this.emailRegex.test(e));
    if (invalidos.length > 0) {
      this.spinner.hide('spinerEmail')
      this.snackBar.showWarn(`Email inválido: ${invalidos.join(', ')}`, "Atención");
      return null;
    }

    return valores;
  }

  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const destinatarios = this.parsearDestinatarios();
    if (!destinatarios || destinatarios.length === 0) {
      if (destinatarios?.length === 0) {
        this.spinner.hide('spinerEmail');
        this.snackBar.showWarn('Agregá al menos un destinatario', "Atención");
      }
      return;
    }

    const request: SendEmailRequest = {
      destinatarios: destinatarios.map(email => ({ receiverAddress: email, receiverName: '' } as ReceiverDto)),
      asunto: this.asunto.value,
      body: this.body.value,
      files: []
    };

    this.enviando = true;
    this.emailService.send(request).subscribe({
      next: () => {
        this.spinner.hide('spinerEmail');
        this.enviando = false;
        this.snackBar.showSuccess('Correo enviado correctamente', "Exito");
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.spinner.hide('spinerEmail');
        this.enviando = false;
        this.snackBar.showError(err, "Error");
      }
    });
  }

  cancelar(): void {
    this.dialogRef.close(false);
  }
}
